/**
 * Business logic for shift breaks
 */

import { BREAK_DEFAULTS } from "../constants";

/**
 * Pick where a newly added break should start.
 *
 * Noon is the default, but it falls outside an overnight shift, so those seed an hour in.
 *
 * @param {Object} shift - Shift with canonical `startTime` / `endTime`
 * @returns {number} - Break start (seconds since midnight)
 */
export const defaultBreakStartTime = (shift) => {
  if (shift.startTime == null || shift.endTime == null) {
    return BREAK_DEFAULTS.START;
  }
  const noonIsInsideShift =
    BREAK_DEFAULTS.START >= shift.startTime &&
    BREAK_DEFAULTS.START + BREAK_DEFAULTS.DURATION <= shift.endTime;
  if (noonIsInsideShift) {
    return BREAK_DEFAULTS.START;
  }
  const latestBreakStart = shift.endTime - BREAK_DEFAULTS.DURATION;
  return Math.max(
    shift.startTime,
    Math.min(
      shift.startTime + BREAK_DEFAULTS.OFFSET_FROM_SHIFT_START,
      latestBreakStart
    )
  );
};
